import * as yup from 'yup';

const AddConstructsSchema = yup.object({
  constructName: yup
    .string()
    .required('Construct name is required')
    .trim()
    .min(1, 'Construct name cannot be empty'),
  description: yup.string().required('Description is required').trim().min(1, 'Description cannot be empty'),
  clinicalImportance: yup
    .string()
    .required('Clinical importance is required')
    .oneOf(['HIGH', 'MEDIUM', 'LOW'], 'Please select a valid clinical importance'),
  updateStrategy: yup
    .string()
    .required('Update strategy is required')
    .oneOf(['HYBRID', 'INTEGRATE', 'REPLACE'], 'Please select a valid update strategy'),
  prompt: yup.string(),
});

export { AddConstructsSchema };
